<!-- Updated request-consent.html synced with project color palette -->
<div class="consent-page">
    <!-- Decorative background elements -->
    <div class="bg-blur-circle circle-1"></div>
    <div class="bg-blur-circle circle-2"></div>

    <div class="consent-card">
        <!-- Header Section -->
        <div class="card-header">
            <div class="logo-area">
                <img src="assets/images/logo.svg" alt="BANXX" class="logo-img" />
            </div>
            <h1 *ngIf="!showConsentsList" class="card-title">Welcome to Banxx</h1>
            <p *ngIf="!showConsentsList" class="card-subtitle">Manage loans, accounts and finances in one place</p>
        </div>

        <form *ngIf="!showConsentsList" [formGroup]="consentForm" (ngSubmit)="onSubmit()" class="consent-form">
            <div class="form-grid">
                <!-- Mobile Number -->
                <div class="form-group full-width">
                    <label for="partyIdentifierValue">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" aria-hidden="true">
                            <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                            <line x1="12" y1="18" x2="12.01" y2="18"></line>
                        </svg>
                        Phone number
                    </label>
                    <div class="input-container">
                        <input type="tel" id="partyIdentifierValue" formControlName="partyIdentifierValue"
                            placeholder="Enter your 10 Digit Number" class="modern-input" maxlength="10" />
                        <span class="input-icon-right">
                            <img src="assets/icons/user.svg" alt="User" class="user-icon" />
                        </span>
                        <div class="input-focus-glow"></div>
                    </div>
                </div>
            </div>

            <!-- Error Feedback -->
            <div class="form-errors" *ngIf="errorMessage">
                <div class="error-banner" role="alert">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        aria-hidden="true">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                    <span>{{ errorMessage }}</span>
                </div>
            </div>

            <!-- Actions -->
            <div class="form-actions">
                <button type="submit" class="prime-button" [disabled]="consentForm.invalid || isLoading">
                    <span class="btn-content" *ngIf="!isLoading">
                        Continue
                        <!-- <svg class="btn-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" aria-hidden="true">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg> -->
                    </span>
                    <span *ngIf="isLoading" class="loader-state">
                        <span class="dot-loader"></span>
                        Fetching your details...
                    </span>
                </button>
            </div>
        </form>

        <!-- In-card consent note -->
        <p *ngIf="!showConsentsList" class="card-consent-note">
            By continuing, you agree to our <a href="#">Terms</a> &amp; <a href="#">Privacy Policy</a>
        </p>

        <!-- In-card bottom footer -->
        <div *ngIf="!showConsentsList" class="card-bottom-footer">
            <span>© 2015-2026 Banxx</span>
            <div class="footer-links">
                <a href="#">Privacy</a>
                <a href="#">Terms</a>
                <a href="#">Contact Us</a>
            </div>
        </div>

        <!-- Consents List Section -->
        <div *ngIf="showConsentsList" class="consents-selection-view">
            <h2 class="section-title">Existing Consents</h2>
            <p class="section-desc">We found the following linked accounts. Select one to continue or create a new one.
            </p>

            <!-- Error Feedback in List View -->
            <div class="form-errors" *ngIf="errorMessage" style="margin-bottom: 16px;">
                <div class="error-banner" role="alert">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                    <span>{{ errorMessage }}</span>
                </div>
            </div>

            <!-- Success Feedback in List View -->
            <div class="form-success" *ngIf="successMessage" style="margin-bottom: 16px;">
                <div class="success-banner" role="status">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>{{ successMessage }}</span>
                </div>
            </div>

            <div class="consents-list">
                <div *ngFor="let consent of consents" class="consent-item">
                    <div class="consent-item__top">
                        <div class="id-wrapper">
                            <span class="tag">CONSENT ID</span>
                            <div class="consent-id-box">
                                {{ consent.consentID || consent.id }}
                            </div>
                        </div>
                        <div class="status-badge" [attr.data-status]="consent.status">
                            {{consent.status}}
                        </div>
                    </div>

                    <div class="consent-divider"></div>

                    <div class="consent-item__bottom">
                        <button class="revoke-btn" (click)="revokeConsent($event, consent)" title="Revoke access">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path d="M3 6h18"></path>
                                <path
                                    d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                </path>
                            </svg>
                            <span>Revoke</span>
                        </button>

                        <button class="select-btn" (click)="selectExistingConsent(consent)">
                            <span>Select Account</span>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2.5">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- Empty state -->
                <div *ngIf="consents.length === 0" class="no-consents-state">
                    <div class="empty-icon">
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5">
                            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z">
                            </path>
                        </svg>
                    </div>
                    <p>No active consents found for this number.</p>
                </div>
            </div>

            <!-- Footer Action -->
            <div class="selection-footer">
                <button type="button" class="add-new-button" (click)="createNewConsent()" [disabled]="isLoading">
                    <ng-container *ngIf="!isLoading">
                        <span>Create New Consent</span>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <line x1="12" y1="5" x2="12" y2="19"></line>
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                    </ng-container>
                    <ng-container *ngIf="isLoading">
                        <span class="dot-loader"></span>
                        <span>Processing...</span>
                    </ng-container>
                </button>

                <button type="button" class="back-btn" (click)="showConsentsList = false; errorMessage=''">
                    ← Try different mobile number
                </button>
            </div>
        </div>
    </div>
</div>